class CalendarUtility {

    constructor(GeneralOptions) {
        this.GeneralOptions = GeneralOptions;
    }

    getMinAdvanceDate({currentItem, ignoreMinAdvanceDatetime}) {
        if (!currentItem.service) {
            throw 'No current service provided';
        }
        // has a service been selected?
        if (!ignoreMinAdvanceDatetime) {
            return currentItem.service.min_advance_datetime;
        } else {
            return moment();
        }

    }

    getMaxAdvanceDate({currentItem}) {
        if (!currentItem.service) {
            throw 'No current item service provided';
        }

        if (this.GeneralOptions.maxAdvanceDatetimeDays) {
            return moment().add(this.GeneralOptions.maxAdvanceDatetimeDays, 'days');
        } else {
            return currentItem.service.max_advance_datetime;
        }
    }

    getMaxDateDuration({maxDate}) {
        //calculate duration of max date from today
        const today = moment().clone();
        const difference = maxDate
            .startOf('day')
            .diff(today.startOf('day'), 'days', true);

        return moment.duration(difference, 'days').humanize();
    }

    canShowPreviousDates({selectedDate, currentItem, minAdvanceDateTime}) {
        if (!minAdvanceDateTime && currentItem) {
            minAdvanceDateTime = currentItem.service.min_advance_datetime;
        }

        const difference = selectedDate.diff(minAdvanceDateTime, 'days');
        return !(!this.GeneralOptions.canShowPreviousDates && (difference <= 0));
    }

    canMakePastBookings() {
        return this.GeneralOptions.canMakePastBookings;
    }

    pastDaysToShow({timeRangeLength, selectedDay, minimumAdvanceDate}) {
        const difference = selectedDay.diff(minimumAdvanceDate, 'days');
        return difference < timeRangeLength ? difference : timeRangeLength;
    }

}

angular
    .module('BB')
    .service('bbCalendarUtility', CalendarUtility);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/utility/calendar_utility.service.js